fx.ns("shared.panels", class Shapes extends fx.components.VBox {

    constructor(shapes, options)
    {
        super(shapes);

        this.options = options;
    }

    create()
    {
        // label
        //this.addChild(new fx.components.Text( {className : "label", text : "Formes"}), {width : "100%", height : 30, top : 0, left : 0} );

        // HBox
        this._parentContainer = new fx.components.HBox("parentContainer");
        this._container = new fx.components.HBox("container");
        this._parentContainer.addChild(this._container, {height : 80, top : 10, left : "center"});
        this.addChild( this._parentContainer, {width : "100%", height : "100%", top : 0, left : 0});

    }

    onDataUpdated(action)
    {
        if (action.type == "init")
        {
            for(let i = 0; i < this.data.length; i++)
            {
                let shape = this.data.getItemAt( i ) ;
                if (!shape.configOnly || fx.get("app") == "config") 
                    this._container.addChild( new shared.renderers.ShapeRenderer( shape, this.options ) ) ;
            }
        }
    }
    

    
});